import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
export const PrehledPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-black text-white py-12 px-4 font-sans" data-id="element-1800">
      <div className="max-w-md mx-auto" data-id="element-1801">
        {/* Profile Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center mb-10" data-id="element-1802">
          <img src="https://cdn.magicpatterns.com/uploads/wwYyc1knDjZXfwtL9PxV4m/Screenshot_2026-03-02_at_22.16.41.png" alt="Ondřej Janík" className="w-24 h-24 rounded-full object-cover object-top mb-4 border border-gray-800 shadow-lg" data-id="element-1803" />
          <h1 className="text-xl font-bold mb-3" data-id="element-1804">Ondřej Janík</h1>
          <a href="https://www.instagram.com/ondra.janikk/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-green-500 transition-colors p-2" aria-label="Instagram" data-id="element-1805">
            <Instagram className="w-6 h-6" data-id="element-1806" />
          </a>
        </motion.div>

        {/* Links Section */}
        <div className="space-y-8" data-id="element-1807">
          {/* Box 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-1808">
            <p className="text-sm text-gray-300 mb-2 font-medium" data-id="element-1809">
              ↓ Chceš svou vysněnou postavu?
            </p>
            <div className="bg-[#111111] border border-gray-800 rounded-2xl p-4 shadow-lg" data-id="element-1810">
              <div className="flex gap-4 mb-5" data-id="element-1811">
                <div className="w-16 h-16 rounded-lg bg-black flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-1812">
                  <img src="https://cdn.magicpatterns.com/uploads/eu7CsV3egr5sfzo6WEhk7c/ZDARMA.png" alt="Rady ZDARMA" className="w-full h-full object-contain" data-id="element-1813" />
                </div>
                <p className="text-sm text-gray-300 leading-relaxed" data-id="element-1814">
                  <strong className="text-white font-bold block mb-1" data-id="element-1815">
                    [Rady ZDARMA]
                  </strong>
                  Rady, díky kterým jsem z úplného začátečníka vybudoval
                  vysněnou postavu.
                </p>
              </div>
              <a href="/rady" className="block w-full bg-green-500 hover:bg-green-400 text-black font-bold text-center py-3.5 rounded-xl transition-all duration-300 shadow-[0_0_15px_rgba(34,197,94,0.3)] hover:shadow-[0_0_25px_rgba(34,197,94,0.5)]" data-id="element-1816">
                Získat přístup
              </a>
            </div>
          </motion.div>

          {/* Box 2 - Meeting ZDARMA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-1817">
            <p className="text-sm text-gray-300 mb-2 font-medium" data-id="element-1818">
              ↓ Chceš online meeting 1:1 kde ti poradím inviduálně?
            </p>
            <div className="bg-[#111111] border border-gray-800 rounded-2xl p-4 shadow-lg" data-id="element-1819">
              <div className="flex gap-4 mb-5" data-id="element-1820">
                <img src="https://cdn.magicpatterns.com/uploads/icE6YXeUwBy7j1kBixCG7N/Screenshot_2026-03-02_at_22.19.54.png" alt="Meeting" className="w-16 h-16 rounded-lg object-cover flex-shrink-0" data-id="element-1821" />
                <p className="text-sm text-gray-300 leading-relaxed" data-id="element-1822">
                  <strong className="text-white font-bold block mb-1" data-id="element-1823">
                    [Meeting ZDARMA]
                  </strong>
                  Zarezervuj si svůj online 1:1 coaching ZDARMA, kde ti poradím
                  co přesně dělat ve tvé situaci, a jak dosáhnout co nejrychleji
                  výsledků.
                </p>
              </div>
              <a href="https://calendly.com/" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-500 hover:bg-green-400 text-black font-bold text-center py-3.5 rounded-xl transition-all duration-300 shadow-[0_0_15px_rgba(34,197,94,0.3)] hover:shadow-[0_0_25px_rgba(34,197,94,0.5)]" data-id="element-1824">
                Zarezervovat meeting
              </a>
            </div>
          </motion.div>

          {/* Box 3 - BODY-HACK */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-1825">
            <p className="text-sm text-gray-300 mb-2 font-medium" data-id="element-1826">
              ↓ Chceš systém který ti pomůže docílit vysněné postavy?
            </p>
            <div className="bg-[#111111] border border-gray-800 rounded-2xl p-4 shadow-lg" data-id="element-1827">
              <div className="flex gap-4 mb-5" data-id="element-1828">
                <div className="w-16 h-16 rounded-lg bg-black flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-1829">
                  <img src="https://cdn.magicpatterns.com/uploads/hkELf1CoWARjpce24djpPS/Screenshot_2026-03-02_at_21.45.44.png" alt="BODY-HACK" className="w-full h-full object-contain p-1" data-id="element-1830" />
                </div>
                <p className="text-sm text-gray-300 leading-relaxed" data-id="element-1831">
                  <strong className="text-white font-bold block mb-1" data-id="element-1832">
                    [BODY-HACK]
                  </strong>
                  Systém, který dává dohromady všechny rady, zkušenosti za léta
                  cvičení a informace ze studií, tak aby pomohli začátečníkům na
                  jejich cestě za vysněnou postavou.
                </p>
              </div>
              <a href="/treninky" className="block w-full bg-green-500 hover:bg-green-400 text-black font-bold text-center py-3.5 rounded-xl transition-all duration-300 shadow-[0_0_15px_rgba(34,197,94,0.3)] hover:shadow-[0_0_25px_rgba(34,197,94,0.5)]" data-id="element-1833">
                Chci více informací
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
};